import { Button, ButtonProps } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface EmailRecipientsAddUsersButtonProps {
  onOpen?: () => void;
  isDisabled: boolean;
  variant?: ButtonProps["variant"];
}

export const EmailRecipientsAddUsersButton = ({
  onOpen,
  isDisabled,
  variant = "outline",
}: EmailRecipientsAddUsersButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="email-recipients-add-users-button"
      onClick={onOpen}
      className="gap-2"
      variant={variant}
      size="sm"
      type="button"
      disabled={isDisabled}
    >
      <UserPlus className="w-5 h-5 mr-1" />
      {t("emailRecipients.addUsers.button")}
    </Button>
  );
};
